import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { unwrapRef } from "@/utils/reactive";

export class OverdoorTotalPriceCalculationStrategy extends CalculationStrategy {
    calculate = (component: ReactiveComponent): PriceResult => {
        return {
            price: this.calculatePriceForType(component, CostDealType),
            priceB2C: this.calculatePriceForType(component, B2CDealType),
            priceB2B: this.calculatePriceForType(component, B2BDealType),
        };
    };

    private calculatePriceForType(
        component: ReactiveComponent,
        dealType: string,
    ) {
        const qty = unwrapRef(component.qty);
        const price = component.price.getSystemPrice(dealType).getValue();

        return price * qty;
    }
}

export class OverdoorWithoutAssetsPriceCalculationStrategy extends CalculationStrategy {
    public calculate(component: ReactiveComponent): PriceResult {
        return {
            price: this.calculateComponentsPriceForType(
                component,
                CostDealType,
            ),
            priceB2C: this.calculateComponentsPriceForType(
                component,
                B2CDealType,
            ),
            priceB2B: this.calculateComponentsPriceForType(
                component,
                B2BDealType,
            ),
        };
    }

    private calculateComponentsPriceForType(
        component: ReactiveComponent,
        dealType: string,
    ) {
        const children = component.components.filter(
            (component) =>
                !["outOfSquare", "overdoor-asset"].includes(component.type),
        );

        return children.reduce((total, child) => {
            const sum = child.sum.getSystemPrice(dealType).getValue();

            return total + sum;
        }, 0);
    }
}
